import { render, staticRenderFns } from "./BudgetOverview.vue?vue&type=template&id=2946de1f&scoped=true&"
import script from "./BudgetOverview.vue?vue&type=script&lang=js&"
export * from "./BudgetOverview.vue?vue&type=script&lang=js&"
import style0 from "./BudgetOverview.vue?vue&type=style&index=0&id=2946de1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2946de1f",
  null
  
)

export default component.exports